import { isCI } from '../utils';
export function artifactId() {
    return {
        'X-Wix-Client-Artifact-Id': !isCI()
            ? process.env.ARTIFACT_ID
            : '',
    };
}
//# sourceMappingURL=artifact-id.js.map